module.exports = __webpack_public_path__ + "img/filesCount.89f8767a.png";